<template>
  <div
    v-if="template"
    id="my-node"
    class="template_background"
    :style="{
      'background-image': template.background?.src
        ? `url(${template.background.src})`
        : '',
      'background-size': template.aspect_ratio.value ? 'cover' : 'contain',
      'background-position': 'center',
      width: '100%',
      height: '100%',
      'aspect-ratio': computedAspectRatio,
    }"
  >
    <!-- <img
      :src="template.background.src"
      alt=""
      :aspect-ratio="
        template.aspect_ratio.value ? template.aspect_ratio.value : 1
      "
      style="width: 100%"
      :style="{ objectFit: 'cover' }"
    /> -->
    <div
      :style="{
        padding: `${template.padding.y}px ${template.padding.x}px`,
        'justify-content': template.align_items,
        'align-items': template.justify_content,
      }"
      style="height: 100%; display: flex; flex-direction: column"
    >
      <div
        v-for="(b, index) in template.blocks"
        :key="index"
        style="width: 100%"
      >
        <div
          v-if="b.type === 'image'"
          class="d-flex"
          :style="{
            'justify-content': b.justify,
            'align-items': b.align,
            padding: `${b.margin.y}px ${b.margin.x}px`,
          }"
          style="width: 100%; height: 100%"
        >
          <img
            :style="{
              width: b.width + '%',
              opacity: b.opacity,
              position: b.position,
              top: b.top + 'px',
              left: b.left + 'px',
              // zIndex: index * -1,
            }"
            :src="b.media && b.media.src ? b.media.src : ''"
            alt=""
            :class="`elevation-${b.dropshadow}`"
          />
        </div>
        <div
          v-if="b.type === 'text'"
          :style="{
            'text-align': b.text_align,
            padding: `${b.margin.y}px ${b.margin.x}px`,
          }"
        >
          <p
            :style="{
              boxShadow: b.card.drop ? '0 4px 8px rgba(0, 0, 0, 0.1)' : null,
              display: 'inline-block',
              background: b.card.value ? `${b.card.color}` : null,
              padding: b.card.value ? `${b.card.size}px` : null,
              borderRadius: b.card.value ? '3%' : null,
              zIndex: index * -1,
              color: b.color,
              'line-height': b.line_height + '%',
              'font-size': b.font.size + 'px',
              'font-weight': b.font.weight,
              'font-style':
                b.format && b.format.includes('italic') ? 'italic' : '',
              'margin-bottom': b.margin.bottom + 'px',
              'margin-top': b.margin.top + 'px',
              'margin-left': b.margin.left + 'px',
              'margin-right': b.margin.right + 'px',

              'text-decoration':
                b.format && b.format.includes('underline') ? 'underline' : '',
            }"
          >
            {{ b.text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["template"],
  data() {
    return {
      naturalRatio: 1,
    };
  },
  computed: {
    computedAspectRatio() {
      return this.template?.aspect_ratio?.value || this.naturalRatio;
    },
  },
  watch: {
    "template.background.src": {
      immediate: true,
      handler(src) {
        if (!this.template?.aspect_ratio?.value && src) {
          const img = new Image();
          img.onload = () => {
            this.naturalRatio = img.width / img.height;
          };
          img.src = src;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.template_background {
  width: 100%;
  background-color: #fff;
}
</style>
